import { assignUnitToTrip, AssignUnitToTripParams } from './assignUnitToTrip';
import { changeUnitStatus, ChangeUnitStatusParams } from './changeUnitStatus';
import { createTrip } from './createTrip';
import { ITripActionData } from './tryUnitAction';

import { container } from '@/container';
import { Connection } from '@/services/Connection';

type DispatchCallback = (action: string, payload: unknown) => Promise<unknown>;

export async function updateLateReason(
  data: ITripActionData,
  dispatch?: DispatchCallback,
): Promise<void> {
  const connection = container.get(Connection);

  const reason = [
    {
      ReasonType: '2',
      ReasonValue: {
        id: data.reasonId as string | number,
        value: null,
      },
    },
  ];

  const tripReasons = [
    {
      ReasonType: '2',
      ReasonValue: {
        id: data.reasonId as string | number,
        value: null,
      },
    },
  ];

  if (connection.isHybrid) {
    if (data.dispatchAction === 'createTrip') {
      await createTrip({ trip: { ...data.trip, reason } as Record<string, unknown> });
    }
    else if (data.dispatchAction === 'assignUnitToTrip') {
      await assignUnitToTrip({
        trip: data.trip as { id: string },
        unitId: data.unitId as string,
        reason: data.reason as AssignUnitToTripParams['reason'],
      });
    }
    else if (data.dispatchAction === 'changeUnitStatus') {
      await changeUnitStatus({
        trip: data.trip as { id: string },
        toStatusId: data.toStatusId,
        fromStatusId: data.fromStatusId,
        toStatusLabel: data.toStatusLabel,
        specialTimestampId: data.specialTimestampId,
        reason: data.reason as ChangeUnitStatusParams['reason'],
      });
    }
    else if (dispatch) {
      await dispatch(data.dispatchAction, data);
    }
  }
  else if (data.dispatchAction === 'createTrip') {
    if (data.trip && data.trip.id) {
      await createTrip({ trip: { ...data.trip, reason: tripReasons } as Record<string, unknown> });
    }
    else {
      await createTrip({ trip: { ...data.trip, tripReasons } as Record<string, unknown> });
    }
  }
  else if (data.dispatchAction === 'assignUnitToTrip') {
    await assignUnitToTrip({
      trip: data.trip as { id: string },
      unitId: data.unitId as string,
      reason: tripReasons as unknown as AssignUnitToTripParams['reason'],
    });
  }
  else if (data.dispatchAction === 'changeUnitStatus') {
    await changeUnitStatus({
      trip: data.trip as { id: string },
      toStatusId: data.toStatusId,
      fromStatusId: data.fromStatusId,
      toStatusLabel: data.toStatusLabel,
      specialTimestampId: data.specialTimestampId,
      reason: tripReasons as unknown as ChangeUnitStatusParams['reason'],
    });
  }
  else if (dispatch) {
    await dispatch(data.dispatchAction, { ...data, reason: tripReasons });
  }
}
